var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{attrs:{"id":"bookingAccordion"}},_vm._l((_vm.bookings.data),function(booking){return _c('BookingAccordionRow',{key:booking.id,attrs:{"booking":booking}})}),1),_vm._v(" "),_c('pagination',{attrs:{"links":_vm.bookings.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }